<template>
    <section class="breadcumb-wrapper circle-shape pt-50px pb-50px position-relative line-shape">
        <div class="container">
            <div class="row align-center  responsive-tablet-col-2 responsive-mobile-col-1">
                <div class="col-md-6" v-if="title">
                    <div class="breadcumb-content">
                        <h1>{{title}}</h1>
                    </div>
                </div>
                <div class="col-md-6" :class="title ? 'text-right' : 'text-left'">
                    <ul class="breadcumb-list d-inline-flex align-center">
                        <li class="d-inline-flex align-center">
                            <router-link to="/">Home</router-link> <el-icon v-if="subpage || currentpage"><ArrowRight /></el-icon>
                        </li>
                        <li class="d-inline-flex align-center" v-if="subpage">
                            {{subpage}} <el-icon v-if="subpage && currentpage"><ArrowRight /></el-icon>
                        </li>
                        <li class="d-inline-flex align-center" v-if="currentpage">
                            {{currentpage}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {ArrowRight} from '@element-plus/icons-vue'

export default {
    name: 'Breadcrumb',
    props: ['title', 'subpage', 'currentpage'],
    components: {
        ArrowRight
    },
    data() {
        return {

        }
    }
}
</script>